import { render, staticRenderFns } from "./CartWidgetStory.vue?vue&type=template&id=383a4f35&"
import script from "./CartWidgetStory.vue?vue&type=script&lang=ts&"
export * from "./CartWidgetStory.vue?vue&type=script&lang=ts&"
import style0 from "./CartWidgetStory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports